import { getCapitalCase, getNumberOfNightsBetweenDates } from '../utils';

import { InfoCardItem } from './info-card-item';
import React from 'react';
import { useTranslation } from 'react-i18next';

type DarkInfoCardProps = {
	confirmationNumber: string | number;

	cardFields: CardFieldProps[];
};

type CardFieldProps = {
	title: string;
	description: string | number;
	textStyle: string | undefined | null;
	span: number;
};

export const DarkInfoCard = ({
	confirmationNumber,

	cardFields,
}: DarkInfoCardProps) => {
	const { t } = useTranslation();
	return (
		<div
			// className="card border-1 rounded-4 m-1 mx-auto w-100"
			className="card border-2 border-dark rounded-4 mx-auto w-100 overflow-hidden"
			style={{ maxWidth: '1000px' }}>
			<div
				className="card-header d-flex flex-row gap-2 align-items-center theme-card-header"
				style={{
					backgroundColor: '#03355C',
					color: '#FFFFFF',
					borderBottom: 0,
					display: 'none',
				}}>
				<p className="m-0">
					{t('SignaturePageConfirmationNumber')}:{'  '}
				</p>
				<p className="m-0">
					<strong>{confirmationNumber}</strong>{' '}
				</p>
			</div>
			<div className="card-body">
				<div className="d-flex flex-wrap">
					{cardFields.map((cardField, index) => (
						<div
							className={`col-${cardField.span} p-2 ${
								cardFields.length == 4 ? 'theme-highlight-amount' : ''
							}`}
							key={index}>
							<InfoCardItem
								title={cardField.title}
								description={cardField.description}
								textStyle={cardField.textStyle}
							/>
						</div>
					))}
					{/* <div className="col-12 mb-3">
						<InfoCardItem
							title="Property Name"
							description={getCapitalCase(propertyName)}
						/>
					</div>
					<div className="col-6 mb-3">
						<InfoCardItem
							title="Arrival Date"
							description={arrivalDate?.toDateString()}
						/>
					</div>
					<div className="col-6 mb-3">
						<InfoCardItem
							title="Departure Date"
							description={departureDate?.toDateString()}
						/>
					</div>
					<div className="col-6 mb-3">
						<InfoCardItem
							title="Adult(s)/Children"
							description={adultChildCount}
						/>
					</div>
					<div className="col-6">
						<InfoCardItem
							title="Number of Nights"
							description={getNumberOfNightsBetweenDates(
								arrivalDate,
								departureDate
							)}
						/>
					</div>
					<div className="col-12">
						<InfoCardItem
							title="Room type"
							description={getCapitalCase(roomType)}
						/> */}
					{/* </div> */}
				</div>
			</div>
		</div>
	);
};
